import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import Spinner from "../../common/Spinner";
import { Actions as PEOPLES_PENSION_ACTIONS } from "./store/smartPensionActions";
import { INTEGRATION_LOGO, INTEGRATION_NAME } from "./store/config";
import { toTitleCase } from "@/components/common/validation/Validators";

const SendDataToSmartPension = ({
	periodId,
	sendPayPeriodToSmartPension,
	getPayPeriodStatus,
	sending,
	status,
	connected,
	complete,
	toggleErrorsModal,
}) => {
	const icon = useMemo(() => {
		if (sending || status === "pending")
			return (
				<Spinner
					style={{ color: "green", width: 12, position: "relative", top: -8, right: -14 }}
					className="animate-spin -ml-1 mr-3"
				/>
			);
		if (status === "success")
			return (
				<CheckCircleIcon style={{ color: "green", width: 15, position: "relative", top: -8, right: -14 }} />
			);
		if (status === "error")
			return <XCircleIcon style={{ color: "red", width: 15, position: "relative", top: -8, right: -14 }} />;
	}, [connected, status, sending]);

	useEffect(() => {
		if (status !== "pending" || document.hidden) return; // if FPS status is not pending, do not check status
		const interval = setInterval(() => {
			if (status !== "pending") clearInterval(interval);
			getPayPeriodStatus(periodId);
		}, 15000); // Check Submission status every 15 seconds
		if (status !== "pending") clearInterval(interval); // if updated, clear interval

		return () => clearInterval(interval); // if component unmounted, clear interval
	}, [status]);

	const canSend = !sending && (!status || status === "error") && complete;

	const title = useMemo(() => {
		if (status) return toTitleCase(status);
		if (sending) return "Sending...";
		if (complete && (!status || status === "error")) return `Send to ${INTEGRATION_NAME}`;
		if (!complete) return "Payroll not complete";
	}, [status, complete]);

	if (!connected || !status) return null;
	return (
		<div
			title={title}
			type="button"
			complete={canSend}
			style={{
				height: "1.5em",
				width: "1.5em",
				borderRadius: "50%",
				position: "relative",
				cursor: "pointer",
				cursor: canSend ? "pointer" : "not-allowed",
				marginLeft: 10,
			}}
			onClick={() => {
				if (status === "error") {
					toggleErrorsModal(periodId);
					return;
				}
				if (canSend) sendPayPeriodToSmartPension(periodId);
			}}
		>
			<img
				src={INTEGRATION_LOGO}
				style={{ width: 24.5 }}
			/>
			{icon}
		</div>
	);
};

const mapStateToProps = (state, { periodId }) => {
	const { smartPension } = { ...state.integration?.pension };
	const currentPeriod = state.payPeriods?.periods?.find(({ id }) => id === periodId);
	const complete = !["no", "false", false, undefined].includes(currentPeriod.complete);

	return {
		connected: smartPension?.connectionId,
		status: smartPension?.payPeriods?.find(({ payPeriodId }) => payPeriodId === periodId)?.status,
		sending: smartPension?.sendingPayroll?.includes(periodId),
		complete,
	};
};

const mapDispatchToProps = (dispatch) => ({
	sendPayPeriodToSmartPension: (periodId) => dispatch(PEOPLES_PENSION_ACTIONS.sendPayPeriodToSmartPension(periodId)),
	getPayPeriodStatus: (periodId) => dispatch(PEOPLES_PENSION_ACTIONS.getPayPeriodStatus(periodId)),
	toggleErrorsModal: (periodId) => dispatch(PEOPLES_PENSION_ACTIONS.toggleErrorsModal(periodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendDataToSmartPension);
